import { render } from "./SimpleCard.vue?vue&type=template&id=14d85e48&ts=true"
import script from "./SimpleCard.vue?vue&type=script&lang=ts"
export * from "./SimpleCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__